import {
    getCulinaryStudioArticleCategories,
    GetCulinaryStudioArticleCategoriesApiResponseSchema,
} from './get-culinary-studio-article-categories';
import {
    getCulinaryStudioArticleCardsByCategoryUid,
    GetCulinaryStudioArticleCardsByCategoryUidApiResponseSchema,
} from './get-culinary-studio-article-cards-by-category-uid';
import {
    getCulinaryStudioService,
    GetCulinaryStudioServiceActionResponseMapper,
} from './get-culinary-studio-service';

export {
    GetCulinaryStudioArticleCategoriesApiResponseSchema,
    GetCulinaryStudioArticleCardsByCategoryUidApiResponseSchema,
    GetCulinaryStudioServiceActionResponseMapper,
};

export const CulinaryStudioPageActions = {
    getCulinaryStudioArticleCategories,
    getCulinaryStudioArticleCardsByCategoryUid,
    getCulinaryStudioService,
};
